<template>
  <fragment>
    <div class="modal-body">
      <iframe
        v-show="url"
        width="100%"
        height="600"
        :src="url"
        frameborder="0"
      ></iframe>
    </div>
    <div class="modal-footer">
      <div class="pull-left">
        <c-button
          type="button"
          theme="default"
          icon="fa-remove"
          @click="$emit('close')"
        >Close
        </c-button>
      </div>
    </div>
  </fragment>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: null
    }
  },
  emits: [
    "close"
  ]
};
</script>
